module.exports = __webpack_public_path__ + "static/6-521c5e6be2895a38f4400b49369d4e1b.png";